(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracPackageDeleteController',NasracPackageDeleteController);

    NasracPackageDeleteController.$inject = ['$uibModalInstance', 'entity', 'NasracPackage'];

    function NasracPackageDeleteController($uibModalInstance, entity, NasracPackage) {
        var vm = this;

        vm.nasracPackage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            NasracPackage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
